export default "__VITE_PUBLIC_ASSET__5c1f9b1c__"